module.exports = __webpack_public_path__ + "img/login-background.eea12197.png";